import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  getAuth,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged,
  getIdToken,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import {
  getFirestore,
  doc,
  setDoc,
  updateDoc,
  getDoc,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getMessaging } from "firebase/messaging";
import { getFunctions } from "firebase/functions";

require('firebase/auth');

const firebaseConfig = {
  apiKey: "AIzaSyBqRGBRb4sliaMCCulyEjaLj5gWV5u0RJM",
  authDomain: "chatio-9ce76.firebaseapp.com",
  projectId: "chatio-9ce76",
  storageBucket: "chatio-9ce76.appspot.com",
  messagingSenderId: "996375241852",
  appId: "1:996375241852:web:cf6c376c1175cb3ffe95f9",
  measurementId: "G-KR11HF0K0L"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const messaging = getMessaging(app);
const functions = getFunctions(app, "us-central1");

export { app, db, auth, storage, messaging, functions };


export const getToken = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      if (user) {
        getIdToken(user).then(
          (idToken) => {
            resolve(idToken);
          },
          (error) => {
            resolve(null);
          }
        );
      } else {
        resolve(null);
      }
    });
  });
};

export const token = async () => {
  try {
    const currentUser = auth.currentUser;
    if (currentUser) {
      const idToken = await currentUser.getIdToken();
      return idToken;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error retrieving ID token:", error);
    return null;
  }
};

export const signInUser = (email, password) => {
  const auth = getAuth();
  return setPersistence(auth, browserLocalPersistence)
    .then(() => {
      return signInWithEmailAndPassword(auth, email, password);
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error(errorCode, errorMessage);
      throw error;
    });
};

export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    console.log(
      "¡El correo electrónico para restablecer la contraseña se envió correctamente!"
    );
  } catch (error) {
    throw new Error(
      "Error al enviar el correo electrónico para restablecer la contraseña: " +
        error.message
    );
  }
};

export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const authInstance = getAuth();
  await setPersistence(authInstance, browserLocalPersistence);
  const result = await signInWithPopup(authInstance, provider);
  const user = result.user;

  const dbInstance = getFirestore();
  const userRef = doc(dbInstance, "users", user.uid);
  const userSnap = await getDoc(userRef);
  if (!userSnap.exists()) {
    await setDoc(userRef, {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName || "",
      phone: "",
      point: "",
      profileImageUrl:
        user.photoURL ||
        "https://firebasestorage.googleapis.com/v0/b/chatio-9ce76.appspot.com/o/user.png?alt=media&token=1ba3ddcf-947c-44ab-a590-6d8bcd483b67",
    });
  }

  return result;
};

export const createUser = async (
  email,
  password,
  displayName,
  phone,
  point
) => {
  try {
    const auth = getAuth();
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );

    const user = userCredential.user;
    const uid = user.uid;

    const db = getFirestore();
    const userRef = doc(db, "users", uid);
    await setDoc(userRef, {
      uid: uid,
      email: email,
      displayName: displayName,
      phone: phone,
      point: point,
      profileImageUrl: "https://firebasestorage.googleapis.com/v0/b/chatio-9ce76.appspot.com/o/user.png?alt=media&token=1ba3ddcf-947c-44ab-a590-6d8bcd483b67",
    });

    return userCredential;
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (uid, displayName, phone, point) => {
  try {
    const db = getFirestore(app);
    const userRef = doc(db, "users", uid);
    await updateDoc(userRef, {
      displayName: displayName,
      phone: phone,
      point: point,
    });
    const userData = await getDoc(userRef);
    if (userData.exists()) {
      return { uid, ...userData.data() };
    } else {
      throw new Error("El usuario no existe");
    }
  } catch (error) {
    throw error;
  }
};

export const uploadImage = async (file) => {
  try {
    const storageRef = ref(storage, 'images/' + file.name); // Crea una referencia a la ubicación en Storage
    await uploadBytes(storageRef, file); // Sube el archivo
    const downloadURL = await getDownloadURL(storageRef); // Obtiene la URL de descarga del archivo
    return downloadURL;
  } catch (error) {
    throw error;
  }
};

export const updateUserProfile = async (uid, profileData) => {
  try {
    const userRef = doc(db, "users", uid);
    await updateDoc(userRef, profileData);
    console.log("Perfil del usuario actualizado correctamente.");
  } catch (error) {
    console.error("Error al actualizar el perfil del usuario:", error);
    throw error;
  }
};